/** Must match `definePageMeta` in `pages/locked.vue`. */
export const LICENSE_LOCKED_ROUTE_NAME = 'license.locked';
